<template>
  <div
    id="UppOfferCardContainer"
    v-when-visible="triggerEventWhenElementIsVisible"
    class="UppOfferCardContainer"
  >
    <FgtsOfferCardB
      v-if="abTest() === 'B'"
      product-label="Saque Aniversário FGTS"
      :partner="offer.partner"
      :min-amount="39"
      :max-amount="50000"
      :interest-rate="1.29"
      @action-forward-click="onContinue"
      @brand-click="displayOfferDetailsModal = true"
      @offer-conditions-click="displayOfferDetailsModal = true"
    />
    <FgtsOfferCard
      v-else
      :partner="offer.partner"
      :min-amount="39"
      :max-amount="50000"
      :interest-rate="1.29"
      @action-forward-click="onContinue"
      @brand-click="displayOfferDetailsModal = true"
      @offer-conditions-click="displayOfferDetailsModal = true"
    />
    <OfferDetailsModal
      v-if="displayOfferDetailsModal"
      :offer="offer"
      :busy="busy"
      :is-fullscreen-mobile="true"
      product-type="Saque Aniversário FGTS"
      :display-faqs="cptdFaq.length > 0"
      :display="displayOfferDetailsModal"
      @close="displayOfferDetailsModal = false"
      @openFaqs="displayFaqsModal = true"
      @submit="onContinue"
    >
      <template #conditions>
        <article>
          <p class="condition">Valor mínimo</p>
          <p class="value">R$ 39,00</p>
        </article>
        <article>
          <p class="condition">Valor máximo</p>
          <p class="value">R$ 50.000,00</p>
        </article>
        <article>
          <p class="condition">Parcelas</p>
          <p class="value">10 anos</p>
        </article>
        <article>
          <p class="condition">Forma de pagamento</p>
          <p class="value">Débito no saldo do FGTS</p>
        </article>
        <article>
          <p class="condition">Taxa de juros</p>
          <p class="value">a partir de 1,49% ao mês</p>
        </article>
      </template>
    </OfferDetailsModal>

    <UppHiringProcessDialog
      :display="displaySteps"
      @close="displaySteps = false"
      @continue="simulate()"
    />

    <CommomQuestionsComponent
      v-if="displayFaqsModal"
      subject="UPP"
      :questions="cptdFaq"
      @close="displayFaqsModal = false"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import whenVisibleDirective from '@/aasgard/directives/when-visible'
import OfferDetailsModal from '@/components/commomComponents/modals/OfferDetailsModal.vue'
import CommomQuestionsComponent from '@/components/commomComponents/CommomQuestionsComponent.vue'
import { PartnersFaq } from '~/helpers/partners/partnersFaq'
import UppHiringProcessDialog from '@/containers/loans/fgts/offer/affiliates/upp/UppHiringProcessDialog.vue'
import FgtsOfferCard from '~/aasgard/components/cards/FgtsOfferCard.vue'
import { JbClevertapEvent } from '~/data/clevertap/jb-clevertap'
import FgtsOfferCardB from '~/aasgard/components/cards/FgtsOfferCardB.vue'
import { abTest } from '~/helpers/abTest'

export default {
  name: 'UppOfferCardContainer',
  components: {
    FgtsOfferCardB,
    FgtsOfferCard,
    UppHiringProcessDialog,
    OfferDetailsModal,
    CommomQuestionsComponent,
  },
  directives: {
    ...whenVisibleDirective,
  },
  data() {
    return {
      displayOfferDetailsModal: false,
      displaySteps: false,
      busy: false,
      displayFaqsModal: false,
      offer: {
        partner: 'UPP',
      },
    }
  },
  computed: {
    ...mapGetters({
      gtUser: 'user/user/gtUser',
      personaData: 'user/persona/personaData',
    }),
    cptdFaq() {
      return PartnersFaq[this.offer?.partner] ?? []
    },
  },
  mounted() {
    this.actInsertIntent({
      identifier: 'PARTNER_UPP_VIEW',
    })
  },
  methods: {
    abTest,
    ...mapActions({
      actEmitGaEvent: 'services/ga/actEmitGaEvent',
      actEmitInfobipButtonClickEvent:
        'services/events/actEmitInfobipButtonClickEvent',
      actInsertIntent: 'user/intent/actInsertIntent',
      actSetLastLoanInteraction: 'ui/user-activity/actSetLastLoanInteraction',
      actCleverTapPushEvent: 'clevertap/actCleverTapPushEvent',
    }),
    onContinue() {
      this.displaySteps = true
      this.displayOfferDetailsModal = false
    },
    simulate() {
      this.actSetLastLoanInteraction('fgts')
      this.actInsertIntent({
        identifier: 'PARTNER_UPP_CLICK',
      })
      this.actCleverTapPushEvent({
        eventName: JbClevertapEvent.BUTTON_CLICK,
        eventData: {
          Product: 'fgts',
          ButtonText: 'consultar_valor',
          URL: location.pathname,
          Platform: navigator.userAgent,
        },
      })
      this.actEmitInfobipButtonClickEvent({
        product: 'fgts',
        button_text: 'consultar_valor',
      })
      this.actEmitGaEvent({
        eventCategory: 'card-upp-fgts',
        eventLabel: 'result-page-click',
        eventAction: `result-page-click`,
      })

      this.$router.push({
        path: '/contratacao/fgts/afiliados/upp/redirecionamento',
      })
    },
    triggerEventWhenElementIsVisible() {
      this.actEmitGaEvent({
        eventCategory: 'card-upp-fgts',
        eventAction: `result-page-visualization`,
        eventLabel: 'result-page-visualization',
      })
    },
  },
}
</script>
<style lang="scss"></style>
